export default __webpack_public_path__ + "static/media/cursor-comment.b3eefbc5.svg";